const fadeElements = document.querySelectorAll('.fade-in-scroll');

// Define the options for the observer
const options = {
  root: null, // use the viewport as the container
  rootMargin: '0px', // no extra margin
  threshold: 0.6 // trigger when 60% of the element is visible
};

// Define the callback function (what happens when visibility changes)
const observerCallback = (entries, observer) => {
  entries.forEach(entry => {
    // Check if the element is currently visible (intersecting)
    if (entry.isIntersecting) {
      const element = entry.target;

      // Check for and apply the data-delay attribute
      const delay = element.getAttribute('data-delay');
      if (delay) {
        // Set the CSS transition-delay property inline
        element.style.transitionDelay = delay;
      }

      // Add the 'appear' class to trigger the CSS transition
      entry.target.classList.add('appear');

      // OPTIONAL: Stop observing once it has appeared
      observer.unobserve(entry.target);
    }
  });
};

// Create the Intersection Observer instance
const observer = new IntersectionObserver(observerCallback, options);

// Tell the observer which elements to watch
fadeElements.forEach(element => {
  observer.observe(element);
});
